// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Close */

.help-desk-close-header-button, .help-desk-close-header-button * {
  cursor: pointer;
}

.help-desk-close-header-button {
  z-index: 2147483003;
  position: absolute;
  width: 51px;
  height: 51px;
  top: 0px;
  right: 0px;
  background-position: center center;
  margin: 12px 8px 12px 2px;
}

.help-desk-close-button-svg {
  width: 51px;
  height: 51px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transform: translateZ(0px);
  margin: 0px auto;
  border-radius: 8px;
}

.help-desk-header-welcome-wrapper {
  transform: translateY(-0.75px);
  opacity: 0.980198;
}

.help-desk-header-welcome-logo svg {
  width: 50px;
  height: 50px;
  display: block;
  margin: auto;
}

.help-desk-header-welcome-logo img {
  height: 50px;
  display: block;
  margin: auto;
}

.help-desk-header-welcome-logo-left img {
  width: 50px;
  height: 50px;
  display: block;
}

.help-desk-header-welcome-logo-right::after {
  content: "";
  display: block;
  clear: both;
}

.help-desk-header-welcome-logo-right img {
  width: 50px;
  height: 50px;
  display: block;
  margin-right: 15px;
  float: right;
}

img {
  height: auto;
}

h1 .help-desk-header-welcome-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

h1 .help-desk-header-welcome-title > span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: rgb(255, 255, 255);
  display: block;
  line-height: 1.5em;
}

h2 .help-desk-header-welcome-message > span {
  color: rgba(255, 255, 255, 0.7);
  display: block;
  font-size: 1em;
  line-height: 1.5em;
  overflow-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./dist/src/components/layout/header/header-welcome/header-welcome.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":["/* Header Close */\r\n\r\n.help-desk-close-header-button, .help-desk-close-header-button * {\r\n  cursor: pointer;\r\n}\r\n\r\n.help-desk-close-header-button {\r\n  z-index: 2147483003;\r\n  position: absolute;\r\n  width: 51px;\r\n  height: 51px;\r\n  top: 0px;\r\n  right: 0px;\r\n  background-position: center center;\r\n  margin: 12px 8px 12px 2px;\r\n}\r\n\r\n.help-desk-close-button-svg {\r\n  width: 51px;\r\n  height: 51px;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  justify-content: center;\r\n  transform: translateZ(0px);\r\n  margin: 0px auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n.help-desk-header-welcome-wrapper {\r\n  transform: translateY(-0.75px);\r\n  opacity: 0.980198;\r\n}\r\n\r\n.help-desk-header-welcome-logo svg {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: block;\r\n  margin: auto;\r\n}\r\n\r\n.help-desk-header-welcome-logo img {\r\n  height: 50px;\r\n  display: block;\r\n  margin: auto;\r\n}\r\n\r\n.help-desk-header-welcome-logo-left img {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: block;\r\n}\r\n\r\n.help-desk-header-welcome-logo-right::after {\r\n  content: \"\";\r\n  display: block;\r\n  clear: both;\r\n}\r\n\r\n.help-desk-header-welcome-logo-right img {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: block;\r\n  margin-right: 15px;\r\n  float: right;\r\n}\r\n\r\nimg {\r\n  height: auto;\r\n}\r\n\r\nh1 .help-desk-header-welcome-title {\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\nh1 .help-desk-header-welcome-title > span {\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  color: rgb(255, 255, 255);\r\n  display: block;\r\n  line-height: 1.5em;\r\n}\r\n\r\nh2 .help-desk-header-welcome-message > span {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  display: block;\r\n  font-size: 1em;\r\n  line-height: 1.5em;\r\n  overflow-wrap: break-word;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
